export const productTypeDefault = {
  addon_trading_days_required: undefined,
  addon_lifetime_performance_account_package_id: undefined,
  addon_type: undefined,
  addon_extra_amount_allowed_payout: undefined,
  addon_new_percent_override_default: undefined,
  addon_disable_percent_default: undefined,
  addon_discount_percent: undefined,
  addon_valid_for_days: undefined,
  addon_extra_allowed_payout_time: undefined,
  type: undefined,
  is_bundle: undefined,
  accounts_in_bundle: undefined,
  weekly_account_payout_max: undefined,
  account_benefits: undefined,
  account_type: undefined,
  is_performance_account: undefined,
  compatible_data_feeds: undefined,
  cash_in_hand: undefined,
  auto_liquidate: undefined,
  drawdown: undefined,
  drawdown_type: undefined,
  trailing_drawdown_stops: undefined,
  trailing_drawdown_stop_at: undefined,
  pa_account_trailing_drawdown_stop_at: undefined,
  allow_reset_of_packages: undefined,
  market_data_type: undefined,
  performance_account_type: undefined,
};

export const productBillingDefault = {
  first_period_value: null,
  second_price: undefined,
  second_period_unit: undefined,
  second_period_value: undefined,
  rebill_times_type: null,
  rebill_times_unit: undefined,
  quantity: null,
  change_quantity: null,
  expire_in_last_day_of_current_month: undefined,
  is_apply_tax: undefined,
  is_apply_convenience_fee: undefined,
  is_enabled: undefined,
};
